/**
 * Transforms raw chatter API response data into the format expected by the UI
 * @param {Array} results - Array of chatter items from API response
 * @returns {Array} Transformed chatter items
 */
export const transformChatterData = (results) => {
  return results.map((el) => {
    const date = new Date(el.recorded_on);
    const milliseconds = date.getTime();
    const millisecondsString = milliseconds.toString();
    let nameParts = el.recorded_by_name.split(" ");
    const newEl = {};
    newEl.id = el.id;
    if (nameParts.length === 2) {
      newEl.avatar = {
        picture: "",
        firstName: nameParts[0],
        lastName: nameParts[1],
      };
    } else {
      newEl.avatar = {
        picture: "",
        firstName: el.recorded_by_name,
        lastName: "",
      };
    }
    newEl.IsExIQtiveBot = false;
    newEl.message = el.note;
    newEl.created_on = millisecondsString;
    newEl.IsHistory = el.is_history;
    return newEl;
  });
};
